import type { BaseUsecase } from '@usecases/base-usecase';
import type { Agent } from '@entities/user';
import type { BusAgentListPayload } from '@main/event-listeners/payloads/bus-agent-list.payload';

export interface StoreAgentListRepository {
  addAgent(agents: Agent[]): Promise<void>;
  getAgents(): Promise<Agent[]>;
}

export interface StoreAgentListEventPublisher {
  publish(nextToken: string | null, fetchStatus: boolean): Promise<void>;
}

export interface StoreAgentListUsecase
  extends BaseUsecase<BusAgentListPayload, void> {
  run(req: BusAgentListPayload): Promise<void>;
}

export class StoreAgentList implements StoreAgentListUsecase {
  constructor(
    private repository: StoreAgentListRepository,
    private publisher: StoreAgentListEventPublisher,
  ) {}

  async run(payload: BusAgentListPayload): Promise<void> {
    setTimeout(async () => {
      const agents = payload.lookupTeammates.items as Agent[]; // Get the agents from the payload.
      await this.repository.addAgent(agents); // Call the getAgents method on the repository.
      const nextToken = payload.lookupTeammates.pageInfo.nextToken;
      await Promise.all([this.publisher.publish(nextToken, !nextToken)]);
    }, 1000);
  }
}
